import { z } from 'zod';

import { MESSAGE_DATA_TYPES } from './discriminators';

export const payloadSchema = z.object({
  type: z.literal(MESSAGE_DATA_TYPES.EXPERT_RELAY),
  contentRole: z.literal('expert_relay'),
  /** Optional per-message override for the attributed expert's display name; falls back to the inquiry's expert when absent. */
  expertName: z.string().optional(),
});

export type ExpertRelayMessageData = z.infer<typeof payloadSchema>;

export const attributesSchema = z.object({
  /** Set by support/API when body relays expert-sourced content into an anonymous thread */
  contentRole: z.enum(['expert_relay']).optional(),
  /** Per-message override for the relayed expert's display name; falls back to the inquiry's expert when absent. */
  expertName: z.string().optional(),
});

export function createExpertRelayMessageData(expertName?: string): ExpertRelayMessageData {
  return {
    type: MESSAGE_DATA_TYPES.EXPERT_RELAY,
    contentRole: 'expert_relay',
    ...(expertName ? { expertName } : {}),
  };
}
